export const homepageIntroAnimation = () => {
	const container = $('.intro-section__industries');

    if ($(container).length == 0) return;

    const itemsContainer = $('.intro-section__industries-wrapper');
    const items = $(itemsContainer).find('.intro-section__industries-item');
    let index = 0;

	setInterval(function() {
        if ($(window).width() < 768) {
            $(items).removeClass('active');
            
            $(items).eq(index).addClass('active');

            mobileAnimation();
        } else {
            $(items).removeClass('active');
            $(items).eq(index).addClass('active');
        }

        if (index == $(items).length - 1) {
            index = 0;
        } else {
            index++;
        }
    }, 3000);

    function mobileAnimation() {
        const prevItems = $('.intro-section__industries-item.active').prevAll();
        let width = $('.intro-section__industries-item.active').prev().outerWidth(true);

        if ($(prevItems).length > 1) {
            width = $(prevItems).eq(0).outerWidth(true);

            $(itemsContainer).append($(prevItems).eq(1));
        }

        $(itemsContainer).css('transform', `translateX(-${width}px)`);
        $(itemsContainer).css('transition', 'transform 0.3s ease');
    }

    $(window).on('resize', function(){
        if ($(window).width() < 768) {
            mobileAnimation();
        } else {
            const sortedItems = $(
                items
                    .get()
                    .sort((a, b) => {
                        return parseInt($(a).attr('data-index')) - parseInt($(b).attr('data-index'));
                    })
            );

            $(itemsContainer).empty().append(sortedItems);
            $(itemsContainer).removeAttr('style');
        }
    }).resize();
};
